import { render } from "./ShiftAutocomplete.vue?vue&type=template&id=6d87578b&ts=true"
import script from "./ShiftAutocomplete.ts?vue&type=script&lang=ts"
export * from "./ShiftAutocomplete.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__